<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">

  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'TIPORESPALDO.LBL_NOMSUBCAT' | translate }}</label>
          <label class="falso-combo-texto">{{_respaldoSubcategoria.nombre}}</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>*{{'TIPORESPALDO.LBL_CLASE' | translate}}:</label>
          <p-dropdown disableTab  id="idClaseRespaldo" name="nomIdClaseRespaldo" [options]="lisClases"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" [disabled]="editarRegistro"
                       formControlName="idClaseRespaldo"
                      (onChange)="verificarSubclase()"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idClaseRespaldo.invalid">
            {{ 'TIPORESPALDO.LBL_CLASE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{'TIPORESPALDO.LBL_SUBCLASE' | translate}}:</label>
          <div *ngIf="lisSubClases.length>0 && !editarRegistro">
            <p-dropdown disableTab  id="idSubClaseRespaldo" name="nomIdSubclaseRespaldo" [options]="lisSubClases"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idSubClaseRespaldo"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idSubClaseRespaldo.invalid">
              {{ 'TIPORESPALDO.LBL_SUBCLASE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <label *ngIf="editarRegistro" style="padding: 3px"
                 class="falso-combo-texto">{{respaldoSubcategoriaDetalle?.nombreSubClaseRespaldo}}</label>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'TIPORESPALDO.LBL_SMMLV' | translate }}</label>
          <input name="valorSMMLV" id="valorSMMLV" type="text" pInputText
                 formControlName="valorSMMLV"  autocomplete="false"
                 appTexto numero-decimal-reactive [entero]="7" [decimales]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.valorSMMLV.invalid">
            {{ 'TIPORESPALDO.LBL_SMMLV' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'TIPORESPALDO.LBL_PORCENTAJE' | translate }}</label>
          <input type="text" pInputText id="porcentaje"
                 name="valorPorcentaje"
                 autocomplete="off"
                 formControlName="valorPorcentaje" porcentaje-reactive
                 [maxlength]="10" [maximo]="999" [decimales]="6"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.valorPorcentaje.invalid">
            {{ 'TIPORESPALDO.LBL_PORCENTAJE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-footer-buttons" *ngIf="respaldoSubcategoriaDetalle">


      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button pButton icon="fa fa-times" label="{{ 'BTN_LIMPIAR' | translate}}" type="button"
                  (click)="limpiar()"></button>
          <button icon="fa fa-refresh" label="{{'BTN_ACTUALIZAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons" *ngIf="!respaldoSubcategoriaDetalle">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6 md:col-offset-6 lg:col-offset-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')"
             [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="datosTabla()" selectionMode="single" dataKey="nombre"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombreClaseRespaldo}}</td>
            <td>{{row.nombreSubClaseRespaldo}}</td>
            <td>{{row.valorSMMLV}}</td>
            <td>{{row.valorPorcentaje}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_ELIMINAR' | translate}}" pButton
                        (click)="eliminar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
